<template>

  <z-dialogo ref="dialogo" persistent largura="800px" titulo="Emitente" scrollable dividers>

    <template v-slot:texto>
      <v-form ref="formulario" v-model="valido" lazy-validation>

        <v-row dense>
          <v-col sm="9">
            <z-text-field
              v-model="emitente.razao"
              label="Razão"
              autofocus
              :rules="[regras.obrigatorio]"
            ></z-text-field>
          </v-col>

          <v-col sm="3">
            <z-select
              v-model="emitente.ambiente"
              label="Ambiente"
              :items="ambientes"
              :rules="[regras.obrigatorio]"
            ></z-select>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col sm="6">
            <z-cpf-cnpj
              v-model="emitente.cnpj"
              label="CNPJ"
              :rules="[regras.obrigatorio]"
            ></z-cpf-cnpj>
          </v-col>

          <v-col sm="6">
            <z-text-field
              v-model="emitente.inscricao_municipal"
              label="Inscrição Municipal"
              :rules="[regras.obrigatorio]"
            ></z-text-field>
          </v-col>

          <v-col sm="3">
            <z-select
              v-model="emitente.estado"
              label="Estado"
              :items="$store.getters['listas/getEstados']"
              :rules="[regras.obrigatorio]"
            ></z-select>
          </v-col>

          <v-col sm="9">
            <z-autocomplete
              v-model="emitente.codigo_municipio"
              label="Cidade"
              :items="cidades"
              :rules="[regras.obrigatorio]"
            ></z-autocomplete>
          </v-col>

          <v-col sm="12">
            <z-text-field
              v-model="emitente.token"
              label="Token de Integração Servidor Api Nfse"
              hint="Mudar somente se for necessário"
              persistent-hint
              :rules="[regras.obrigatorio]"
            ></z-text-field>
          </v-col>

        </v-row>

        <v-subheader class="text--primary">Impostos</v-subheader>
        <v-divider class="mb-2"></v-divider>

        <v-row dense>
          <v-col sm="3">
            <z-campo-valor dense label="Tributos" v-model="emitente.tributos" suffix="%"></z-campo-valor>
          </v-col>
          <v-col sm="3">
            <z-campo-valor dense label="ISS" ref="iss" v-model="emitente.iss" suffix="%"></z-campo-valor>
          </v-col>
          <v-col sm="3">
            <z-campo-valor dense label="CSLL" ref="csll" v-model="emitente.csll" suffix="%"></z-campo-valor>
          </v-col>
          <v-col sm="3">
            <z-campo-valor dense label="COFINS" ref="cofins" v-model="emitente.cofins" suffix="%"></z-campo-valor>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col sm="3">
            <z-campo-valor dense label="PIS" ref="pis" v-model="emitente.pis" suffix="%"></z-campo-valor>
          </v-col>
          <v-col sm="3">
            <z-campo-valor dense label="IR" ref="ir" v-model="emitente.ir" suffix="%"></z-campo-valor>
          </v-col>
          <v-col sm="3">
            <z-campo-valor dense label="ICMS" ref="ir" v-model="emitente.icms" suffix="%"></z-campo-valor>
          </v-col>
          <v-col sm="3">
            <z-campo-valor dense label="IBPT" ref="ibpt" v-model="emitente.ibpt" decimais="4"></z-campo-valor>
          </v-col>
        </v-row>

        <v-col sm="12" class="mb-2">
          <v-checkbox class="my-0 shrink" color="primary" label="Optante Simples Nacional" v-model="emitente.simples_nacional"
            hide-details></v-checkbox>
        </v-col>
      </v-form>
    </template>

    <template v-slot:actions_right>
      <v-btn
        text
        :disabled="loading"
        @click="cancelar"
      >Cancelar</v-btn>
      <v-btn
        color="primary"
        :loading="loading"
        :disabled="!valido || loading"
        @click="confirmar"
      >Salvar</v-btn>
    </template>

  </z-dialogo>

</template>

<script>
import emitentesApi from "@/app/services/emitentes.js"
import { mapGetters } from 'vuex';
import * as regras from '@/app/helpers/validacoes.js';

export default {
  computed: {
    ...mapGetters('listas', ['getCidades']),
    cidades() {
      return this.getCidades(this.emitente.estado);
    },
  },

  data() {
    return {
      regras: { ...regras },
      loading: false,
      valido: false,
      emitente: {
        id: null,
        razao: '',
        cnpj: '',
        inscricao_municipal: '',
        estado: 'PE',
        codigo_municipio: '',
        token: '',
        tributos: 0,
        iss: 0,
        csll: 0,
        cofins: 0,
        pis: 0,
        ir: 0,
        icms: 0,
        ibpt: 0,
        simples_nacional: 0,
        ambiente: 2
      },
      ambientes: [
        { text: 'Produção', value: 1 },
        { text: 'Homologação', value: 2 },
      ],
    }
  },

  methods: {

    async abrir() {
      await this.$store.dispatch('listas/estados');
      await this.carregarEmitente();
      this.$refs.dialogo.abrir();
    },

    fechar() {
      this.$refs.dialogo.fechar();
    },

    async carregarEmitente(emitente) {
      try {
        const response = await emitentesApi.emitente();
        this.emitente = response.data;
      } catch (error) {
        if (error.response && error.response.status === 404) {
          this.limparForm();
        }
      }
    },

    confirmar() {
      if (this.emitente.id) {
        this.atualizar(this.emitente);
      } else {
        this.salvar(this.emitente);
      }
    },

    async salvar(emitente) {

      try {
        this.loading = true;
        const response = await emitentesApi.store(emitente);
        this.$emit('onSalvar', response);
        this.fechar();
      } catch (error) {
        console.log(error);
        this.$emit('onErro');
      } finally {
        this.loading = false;
      }

    },

    async atualizar(emitente) {

      try {
        this.loading = true;
        const response = await emitentesApi.update(emitente);
        this.$emit('onAtualizar', response);
        this.fechar();
      } catch (error) {
        console.log(error);
        this.$emit('onErro');
      } finally {
        this.loading = false;
      }

    },

    async remover(emitente) {

      try {
        this.loading = true;
        await emitentesApi.destroy(emitente.id);
        this.$emit('onRemover', emitente.id);
        this.fechar();
      } catch (error) {
        console.log(error);
        this.$emit('onErro');
      } finally {
        this.loading = false;
      }

    },

    cancelar() {
      this.$emit('onCancelar');
      this.fechar();
    },

    limparForm() {

      setTimeout(() => {
        // this.$refs.formulario.reset();

        this.emitente = {
          id: null,
          razao: '',
          cnpj: '',
          inscricao_municipal: '',
          estado: '',
          codigo_municipio: '',
          token: '',
          tributos: 0,
          iss: 0,
          csll: 0,
          cofins: 0,
          pis: 0,
          ir: 0,
          icms: 0,
          ibpt: 0,
          simples_nacional: 0,
          ambiente: 2
        }

      }, 500);
    },
  },

}
</script>

<style scoped>
.container.grid-list-md .layout .flex {
  padding-top: 0px;
  padding-right: 4px;
  padding-bottom: 0px;
  padding-left: 4px;
}
</style>
